module.exports = __webpack_public_path__ + "img/sc2.49149a38.svg";